import { ERightType, type ISubscribeProductDTO, type TPaywallSlotProduct } from '@/apis/commerce';

/**
 * 折扣订阅判断：自动续订订阅且服务端下发优惠字段，优惠价低于原价。
 * discount_period_num >= 1 即视为折扣订阅（含首期与多期优惠）。
 * 字段未下发时一律 false，普通订阅保持线上逻辑。
 */
export function isDiscountSubscribe(product: TPaywallSlotProduct | undefined): product is ISubscribeProductDTO {
    if (product?.right_type !== ERightType.Membership) {
        return false;
    }
    const subscribe = product as ISubscribeProductDTO;
    const discountPriceCents = subscribe.discount_price_cents;
    return (
        (subscribe.discount_period_num ?? 0) >= 1 &&
        discountPriceCents != null &&
        discountPriceCents < subscribe.price_cents
    );
}

/** 折扣比例（如 50）；仅折扣订阅有值，取整规则 Math.round */
export function resolveSubscribeDiscountPercent(product: TPaywallSlotProduct): number | undefined {
    if (!isDiscountSubscribe(product)) {
        return undefined;
    }
    return Math.round((1 - (product.discount_price_cents as number) / product.price_cents) * 100);
}

/** 订阅周期（vip_date）→ 卡面标题 i18n key；标题前端按周期展示，不使用后端返回的 name。覆盖 vip_date 全部枚举（Day/Week/Month/Quarter/Year） */
const VIP_DATE_PLAN_I18N_KEY: Record<string, string> = {
    Day: 'paywall_plan_daily',
    Week: 'paywall_plan_weekly',
    Month: 'paywall_plan_monthly',
    Quarter: 'paywall_plan_quarterly',
    Year: 'paywall_plan_annual',
};

/** 按 vip_date 解析卡面标题 key，未识别时返回 undefined（调用方自行兜底） */
export function resolveSubscribePlanI18nKey(vipDate?: string): string | undefined {
    return vipDate ? VIP_DATE_PLAN_I18N_KEY[vipDate] : undefined;
}
